import React from "react";
import LoadingSpinner from "./components/LoadingSpinner";
import { useAuth } from "./context/AuthContext";
import { Routes, Route } from "react-router-dom";
import ChatPage from "./pages/ChatPage";
import LandingPage from "./pages/landingpage";
import RequireAuth from "./context/RequireAuth";
import ErrorBoundary from "./components/ErrorBoundary";

export default function App() {
  const { inProgress } = useAuth();
  const authInitializing = inProgress !== "none"; // MSAL interaction in progress

  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/chat"
          element={
            <RequireAuth>
              {authInitializing ? (
                <LoadingSpinner
                  fullscreen
                  label="Preparing secure session..."
                />
              ) : (
                <ChatPage />
              )}
            </RequireAuth>
          }
        />
      </Routes>
    </ErrorBoundary>
  );
}
